import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import TopBar from '@/components/shared/TopBar';
import { toast } from 'sonner';

const LegalPage = ({ pageKey, title }) => {
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchContent();
  }, [pageKey]);

  const fetchContent = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('app_content')
        .select('content')
        .eq('key', pageKey)
        .single();

      if (error) throw error;

      setContent(data.content);
    } catch (error) {
      console.error('Error fetching content:', error);
      toast.error('İçerik yüklenirken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-white" data-testid={`legal-${pageKey}`}>
      {/* Top Bar */}
      <TopBar title={title} onBack={handleBack} />

      {/* Content */}
      <div className="px-5 py-2.5">
        {loading ? (
          <div className="flex justify-center py-10">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-ink"></div>
          </div>
        ) : (
          <div className="prose prose-sm max-w-none">
            <p className="text-xs font-light text-black whitespace-pre-wrap leading-relaxed">
              {content}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

// Export specific pages
export const AboutPage = () => <LegalPage pageKey="about" title="Hakkımızda" />;
export const TermsPage = () => <LegalPage pageKey="terms" title="Kullanım Koşulları" />;
export const PrivacyPage = () => <LegalPage pageKey="privacy" title="Gizlilik Politikası" />;
export const KVKKPage = () => <LegalPage pageKey="kvkk" title="KVKK" />;

export default LegalPage;
